import { useQuery } from "@tanstack/react-query";
import { staffLocationService } from "../services/staff-location.service";
import type { LiveStaffLocationParams, StaffLocationHistoryParams } from "../types";

export const staffLocationKeys = {
	all: ["staff-location"] as const,
	live: (params?: LiveStaffLocationParams) => [...staffLocationKeys.all, "live", params] as const,
	history: (staffId: string, params?: StaffLocationHistoryParams) =>
		[...staffLocationKeys.all, "history", staffId, params] as const,
};

export function useStaffLocationLive(
	params?: LiveStaffLocationParams,
	options?: { enabled?: boolean }
) {
	return useQuery({
		queryKey: staffLocationKeys.live(params),
		queryFn: () => staffLocationService.getLive(params),
		refetchInterval: 30_000,
		enabled: options?.enabled ?? true,
	});
}

export function useStaffLocationHistory(
	staffId: string,
	params: Pick<StaffLocationHistoryParams, "from" | "to">
) {
	return useQuery({
		queryKey: staffLocationKeys.history(staffId, params),
		queryFn: () => staffLocationService.getHistoryRange(staffId, params),
		enabled: !!staffId,
	});
}
